import { connect } from "react-redux";

import AuthorizedRoute from "./AuthorizedRoute";

export default connect(state => ({
	authorized: state.user.isAuthorized,
	location: state.router.location
}))(AuthorizedRoute);
